<script lang="ts" setup>
import { RouterView } from 'vue-router'
</script>

<template>
    <main class="main container">
        <RouterView />
    </main>
</template>
